import { CSSProperties, TypographyOptions } from "@mui/material/styles/createTypography";

const typographiesCommonProps: CSSProperties = {
  fontFamily: 'PP Neue Montreal, sans-serif',
};

export const typography: TypographyOptions = {
  h1: {
    ...typographiesCommonProps,
    fontSize: '56px',
  },
  h2: {
    ...typographiesCommonProps,
    fontSize: 39,
  },
  h3: {
    ...typographiesCommonProps,
    fontSize: 31,
  },
  h4: {
    ...typographiesCommonProps,
    fontSize: 25,
  },
  headline: {
    ...typographiesCommonProps,
    fontSize: 20,
  },
  body1: {
    ...typographiesCommonProps,
    fontSize: 16,
  },
  subtitle: {
    ...typographiesCommonProps,
    fontSize: 13,
  },
  caption: {
    ...typographiesCommonProps,
    fontSize: 11,
  },
  footnote: {
    ...typographiesCommonProps,
    fontSize: 10,
  }
};
